import {dropdownNodes} from './dropdownNodes';

const settings = ({
  api: {
    url: '/api/search/users?query={query}',
    resultSelectorJSONata: '$.content[].{\'name\': [fullName, email][0], \'value\': id, \'link\': \'/people/\' & id, \'image\': \'/avatar/\' & id, \'imageClass\': \'ui circular image icon icon-18\'}',
  },
});

export const assigneeNodes = view => dropdownNodes({
  view, id: 'assignee', name: 'assignee', text: 'Assignee', settings, clearable: true,
});

export const userNodes = view => dropdownNodes({
  view, id: 'user', name: 'user', text: 'User', settings, clearable: true,
});

export const usersNodes = view => dropdownNodes({
  view, id: 'users', name: 'users', text: 'Users', settings, multiple: true, clearable: true,
});